import React, { Component } from 'react';
import { Row, Col, List, Checkbox, Button, Form, Icon, Collapse, Input, Tooltip, Progress, Popconfirm, message } from 'antd';
import { GroceryList as GroceryListApi} from '../../../../services/api';
import { Unit } from '../../../../components/Label';
import ItemForm from './ItemForm';
import Spinner from '../../../../components/Spinner';

const WrappedItemForm = Form.create()(ItemForm);
const customGroup = 'Tillagda av dig';

export default class GroceryList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: {
                list: false,
                item: false,
                title: false,
                deleteItem: false
            },
            items: [],
            list: { meta: { completed: 0, total: 0 } },
            customItem: {},
            modalVisible: false,
            activePanels: [],
            editing: false,
        };

        this.grocerListApi = new GroceryListApi(props);
    }

    componentDidMount() {
        this.findList();
    }

    findList = () => {
        const { loading } = this.state;
        loading.list = true;
        this.setState({ loading });

        this.grocerListApi.find(this.props.match.params.id)
            .then(res => {
                this.setState({ list: res.data.data });
                this.convertIngredients(res.data.data);
            })
            .catch(() => {
                this.grocerListApi.retry({ cb: this.findList });
            });
    }

    convertIngredients = (list) => {
        const { loading } = this.state;
        const data = [];
        list._embedded['varma:items'].data.forEach(i => {
            if (i.ingredient.origin_id === '') {
                return;
            }
            data.push({
                ingredient_id: i.ingredient.origin_id,
                from: i.ingredient.unit,
                to: 'PC',
                qty: i.ingredient.qty,
                ref: i.id
            })
        });

        const url = list._links['convert-ingredients'].href;
        this.grocerListApi.raw().post(url, data)
            .then(res => {
                const items = {};
                list._embedded['varma:items'].data.map(i => {
                    res.data.data.forEach(j => {
                        if (i.id === j.ref) {
                            i.ingredient.unit = j.unit;
                            i.ingredient.qty = j.qty;
                            i.group = j.group.data.title;
                        }
                    });
                    return i;
                }).forEach(i => {
                    i.group = i.group ? i.group : customGroup;
                    const group = i.group;
                    if (!items[group]) {
                        items[group] = {total_completed: 0, items: []};
                    }
                    items[group].items.push(i);
                    items[group].total_completed += i.completed ? 1 : 0;
                });

                loading.list = false;
                this.setState({ items, activePanels: Object.keys(items), loading });
            })
            .catch(_ => {
                this.grocerListApi.retry({ cb: this.convertIngredients });
            })
    }

    completeItem = (item) => {
        const { items, list } = this.state;
        const completed = !item.completed;
        const index = items[item.group].items.findIndex(i => i.id === item.id);
        items[item.group].items[index].completed = completed;
        
        if (completed) {
            items[item.group].total_completed++;
            list.meta.completed++;
        } else {
            items[item.group].total_completed--;
            list.meta.completed--;
        }
        
        this.setState({ items, list });

        this.grocerListApi.raw().patch(item._links.patch.href, { completed: completed })
            .then(_ => {})
            .catch(_ => {
                this.grocerListApi.retry({ params: [item], cb: this.completeItem });
            });
    }

    onItemSubmit = (data) => {
        if (data.id) {
            this.updateItem(data);
            return;
        }
        this.createItem(data);
    }

    createItem = (data) => {
        const { list, loading } = this.state;
        loading.item  = true;
        this.setState({ loading });

        this.grocerListApi.raw().post(list._links['add-item'].href, data)
            .then(res => {
                const { items, list } = this.state;
                res.data.data.group = customGroup;

                if (!items[customGroup]) {
                    items[customGroup] = { items: [], total_completed: 0 };
                }
                items[customGroup].items.push(res.data.data);
                loading.item = false;
                list.meta.total++;
                this.setState({ loading, items, list, modalVisible: false });
            })
            .catch(_ => {
                this.grocerListApi.retry({ params: [data], cb: this.createItem });
            });
    }

    updateItem = (data) => {
        const { item, loading } = this.state;
        loading.item  = true;
        this.setState({ loading: true });
        this.grocerListApi.raw().patch(item._links.patch.href, data)
            .then(res => {
                const items = this.state.items;
                const index = items[item.group].items.findIndex(i => i.id === res.data.data.id)
                res.data.data.group = item.group;
                items[item.group].items[index] = res.data.data;
                loading.item  = false;
                this.setState({ loading, items, modalVisible: false });
            })
            .catch(_ => {
                this.grocerListApi.retry({ params: [data], cb: this.updateItem });
            });
    }

    deleteItem = (item) => {
        const { loading, list } = this.state;
        loading.deleteItem = true;
        this.setState({ loading });

        this.grocerListApi.raw().delete(item._links.delete.href)
            .then(() => {
                const items = this.state.items;
                const index = items[item.group].items.findIndex(i => i.id === item.id)
                
                if (item.completed) {
                    items[item.group].total_completed--;
                    list.meta.completed--;
                }

                list.meta.total--;
                items[item.group].items.splice(index, 1);
                loading.deleteItem = false;

                if (items[item.group].items.length === 0) {
                    delete items[item.group];
                }
                message.success(`${item.title} har blivit borttagen.`);
                this.setState({ loading, items, list });
            })
            .catch(_ => {
                this.grocerListApi.retry({ params: [item], cb: this.deleteItem });
            });
    }

    editItem = (item) => {
        this.setState({ item, modalVisible: true });
    }

    showAddModal = () => {
        this.setState({ modalVisible: true, item: null });
    }

    editTitle = () => {
        this.setState({ editing: true });
    }

    onTitleChange = (e) => {
        const { list } = this.state;
        list.title = e.target.value;
        this.setState({ list });
    };

    saveList = () => {
        const { list, loading } = this.state;
        loading.title  = true;
        this.setState({ loading, editing: false });
        this.grocerListApi.raw().patch(list._links.patch.href, { title: list.title })
            .then(() => {
                loading.title  = false;
                this.setState({ loading });
            })
            .catch(_ => {
                this.grocerListApi.retry({ cb: this.saveList });
            });
    }

    deleteList = (list) => {
        this.grocerListApi.raw().delete(list._links.delete.href)
            .then(() => {
                this.props.history.push('/groceries');
            })
            .catch(_ => {
                this.grocerListApi.retry({ params: [list], cb: this.deleteList });
            })
    }

    render() {
        const { loading, list, items, item, modalVisible, activePanels, editing } = this.state;
        
        return (
            <Row>
                <Col xs={24} sm={12}>
                    {!editing && (
                        <h2>
                            {list.title}
                            {loading.title && <Icon type="loading" />}
                            {!loading.title && (
                                <Tooltip title="Redigera titel">
                                    <a onClick={this.editTitle} style={{ color: '#555' }}>
                                        <Icon type="edit" style={{ marginLeft: '15px' }} />
                                    </a>
                                </Tooltip>                               
                            )}
                        </h2>
                    )}
                    {editing && <Input autoFocus value={list.title} onChange={this.onTitleChange} onBlur={this.saveList} />}
                </Col>

                <Col xs={24} sm={12}>
                    <Popconfirm
                        title={`Är du säker på att du vill radera: ${list.title}`}
                        onConfirm={() => { this.deleteList(list) }}
                        cancelText="Nej"
                        okText="Ja"
                    >
                        <Button className="menu-action-btn" type="danger" icon="delete" loading={loading.delete}>
                            Radera
                        </Button>  
                    </Popconfirm>
                    
                    <Button className="menu-action-btn" type="primary" icon="plus" onClick={this.showAddModal}>
                        Lägg till
                    </Button>
                    
                </Col>
                <Col span={24}>
                    <Progress  
                        percent={(list.meta.completed / list.meta.total) * 100} 
                        format={() => `${list.meta.completed}/${list.meta.total}`} 
                        strokeColor="#EF7C39" 
                        style={{ marginBottom: '20px' }}
                    />

                    <Collapse bordered={false} activeKey={activePanels} onChange={activePanels => this.setState({ activePanels })}>
                        {Object.keys(items).map(group => (
                            <Collapse.Panel header={`(${items[group].total_completed}/${items[group].items.length}) - ${group}`} key={group}>
                                <List
                                    size="large"
                                    dataSource={items[group].items}
                                    renderItem={this.renderItem}
                                />
                            </Collapse.Panel>
                        ))}
                    </Collapse>

                    <Spinner loading={loading.list} />
                </Col>
                <WrappedItemForm visible={modalVisible} list={list} item={item} loading={loading.item} onSubmit={this.onItemSubmit} />
            </Row>
        );
    }

    renderItem = (item) => (
        <List.Item className={item.completed ? 'item-completed' : ''} style={{ fontSize: '18px' }}>
            <Checkbox checked={item.completed} value={item.completed} onChange={() => this.completeItem(item)} style={{ marginRight: '15px' }} />
            <span onClick={() => this.completeItem(item)} style={{ cursor: 'pointer' }}>
                {item.ingredient.qty} <Unit format="short" type={item.ingredient.unit} /> {item.title}
            </span>
            <Tooltip title={`Redigera ${item.title}`}>
                <a onClick={() => this.editItem(item)} style={{ color: '#555' }}>
                    <Icon type="edit" style={{ marginLeft: '15px' }} />
                </a>
            </Tooltip>
            <Tooltip title={`Radera ${item.title}`}>
                <a onClick={() => this.deleteItem(item)} style={{ color: '#555' }}>
                    <Icon type="delete" style={{ marginLeft: '15px' }} />
                </a>
            </Tooltip>
        </List.Item>    
    )
}


// WEBPACK FOOTER //
// ./src/screens/dashboard/components/grocery-list/GroceryList.js